module.exports = __webpack_public_path__ + "static/logo-66227ce10c84cadfbcca8008eefc5df1.png";